import React from 'react'
import { HtmlContent } from 'utils'

import styles from './styles/table_component.module.scss'

const TableComponent = ({ title, description, body, label }) => {
  return (
    <section className={styles.table_component}>
      {
        title !== ''
          ? <h2 className={styles.table_component__title}>
            {title}
          </h2>
          : null
      }

      {
        description !== ''
          ? <HtmlContent content={description} className={styles.table_component__description} />
          : null
      }

      {
        body !== ''
          ? <HtmlContent content={body} className={styles.table_component__table} />
          : null
      }

      {
        label !== ''
          ? <HtmlContent content={label} className={styles.table_component__footnote} />
          : null
      }
    </section>
  )
}

export default TableComponent